import { getImageSources } from "@dotcom/dato";
import {
  AspectRatio,
  AspectRatios,
  Breakpoints,
  Colors,
  Grid,
  GridColumn,
  Image,
  Picture,
  Section,
  Spacer,
  Spacings,
} from "@polestar/component-warehouse-react";

interface LogoTilesProps {
  readonly tiles: Array<{
    id: string;
    url: string;
    alt?: string;
  }>;
}

const LogoTiles = ({ tiles }: LogoTilesProps) => {
  return (
    <Section backgroundColor={Colors.signalWhite}>
      <Spacer
        spacing={{ mobile: Spacings.large, desktop: Spacings.xxxxLarge }}
      />

      <Grid>
        {tiles?.map((tile) => {
          const imageSources = getImageSources({
            mobile: {
              breakpoint: Breakpoints.mobile,
              imageWidth: 224,
              alt: tile.alt ?? "",
              url: tile.url,
            },
            desktop: {
              breakpoint: Breakpoints.desktop,
              imageWidth: 264,
              alt: tile.alt ?? "",
              url: tile.url,
            },
            desktopWide: {
              breakpoint: Breakpoints.desktopWide,
              imageWidth: 264,
              alt: tile.alt ?? "",
              url: tile.url,
            },
            tablet: {
              breakpoint: Breakpoints.tablet,
              imageWidth: 224,
              alt: tile.alt ?? "",
              url: tile.url,
            },
          });

          return (
            <GridColumn
              key={tile.id}
              span={{ mobile: 2, desktop: 2, tablet: 2 }}
            >
              <AspectRatio ratio={AspectRatios.square}>
                <Picture stretch>
                  {imageSources.sources.map(({ media, srcSet }) => {
                    return <source key={media} srcSet={srcSet} media={media} />;
                  })}
                  <Image
                    stretch
                    src={imageSources.source}
                    alt={imageSources?.alt ?? ""}
                    objectFit="cover"
                    objectPosition="50% 50%"
                  />
                </Picture>
              </AspectRatio>
            </GridColumn>
          );
        })}
      </Grid>

      <Spacer
        spacing={{ mobile: Spacings.large, desktop: Spacings.xxxxLarge }}
      />
    </Section>
  );
};

export default LogoTiles;
